// @flow

const styles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex'
  })
};

export default styles;